<template>
  <a
    :href="previewUrl"
    target="_blank"
    class="bg-card-background mb-2 p-4 rounded-8 w-full flex items-center justify-between gap-4"
  >
    <img class="w-12 h-12" :src="thumbnailUrl" alt="thumbnail" />
    <div
      class="truncate whitespace-nowrap overflow-hidden flex flex-col items-start text-white"
    >
      <p class="font-bold">{{ title }}</p>
      <a :href="previewUrl">{{ previewUrl }}</a>
    </div>
    <i class="text-base leading-4 icon-play text-grayscale-96" />
  </a>
</template>
<script setup lang="ts">
defineProps({
  previewUrl: {
    type: String,
  },
  thumbnailUrl: {
    type: String,
  },
  title: {
    type: String,
  },
});
</script>
